import React, { useEffect } from "react";
import ButtonT from "../../components/atoms/ButtonT";
import InputGroup from "../../components/atoms/InputGroup";
import Title from "../../components/atoms/Title";
import TitleDetail from "../../components/atoms/TitleDetail";
import Navbar from "../../components/main/Navbar";
import SearchOrder from "../../components/atoms/SearchOrder";
import Table from "../../components/orderpage/TableOrder";
import { HeaderOrderAdd } from "../../data/TablesHeader";
import { OrderAddUseContext } from "../../context/AdminDashboard/OrderAddContext";
import BtnModal from "../../components/atoms/BtnModal";
import Calendar from "../../components/orderpage/Calendar";
import SelectModal from "../../components/atoms/SelectModal";
import { Toaster } from "react-hot-toast";

const AddOrder = () => {
  const {
    onchangeInput,
    orderTable,
    onchangeSend,
    jsonArray,
    totalCost,
    doneAdd,
    changestatus,
  } = OrderAddUseContext();

  useEffect(() => {
    document.title = "افزودن سفارش جدید";
  }, []);

  let accessValues = [
    { value: "در انتظار برسی", label: "در انتظار برسی" },
    { value: "مدیر کل", label: "مدیر کل" },
    { value: "برنامه نویس", label: "برنامه نویس" },
  ];
  let postvalue = [
    { value: "شرکت ملی پست ایران", label: "شرکت ملی پست ایران" },
    { value: "شرکت ملی پست ملت", label: "شرکت ملی پست ملت" },
    { value: "شرکت زرین پال", label: "شرکت زرین پال" },
  ];

  return (
    <>
      <div className="pb-7.5px">
        <Navbar titles={["سفارش‌ها", "افزودن سفارش جدید"]} />
      </div>
      {/* // loading */}
      <div
        className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px "
        dir="rtl">
        <div className="flex flex-row justify-between items-center h-10  ">
          <div className="flex flex-row ">
            <Title text="افزودن سفارش جدید" />
          </div>

          <ButtonT text="برگشت به لیست" path={"/admin/order"} link={true} />
        </div>
        <TitleDetail title={"اطلاعات کلی"} />
        <div className="flex flex-row justify-between w-full gap-5 mt-25">
          <InputGroup
            iconName={"box-search"}
            label="شماره سفارش (پیگیری)"
            width={"w-1/4"}
            id="ordernumber"
            onchange={onchangeInput}
            placeholder="مانند 65462456987"
          />
          <InputGroup
            iconName={"document-text"}
            label="شماره فاکتور"
            width={"w-1/4"}
            id="factorNumber"
            onchange={onchangeInput}
            placeholder="مانند 5852456987"
          />
          <Calendar width={"w-256"} />
          {/* <InputGroup
            iconName={"search-status"}
            label="وضعیت فعلی"
            readOnly={true}
            width={"w-1/4"}
          /> */}
          <SelectModal
            iconName={"search-status"}
            label="وضعیت فعلی"
            readOnly={true}
            style={"w-1/4 justify-between"}
            values={accessValues}
            maxWidth="256px"
            minWidth={"150px"}
            onchange={changestatus}
            placeholder={"یک گزینه را انتخاب کنید"}
            able={true}
          />
        </div>
        <TitleDetail title={"اطلاعات گیرنده سفارش"} />
        <div className="flex flex-row justify-between w-full gap-5 mt-25">
          <InputGroup
            iconName={"userF"}
            label="تحویل گیرنده"
            id="receiver"
            onchange={onchangeInput}
            placeholder={"مانند آرش فکری"}
          />
          <InputGroup
            iconName={"call"}
            label="شماره تلفن همراه"
            onchange={onchangeInput}
            id="phone"
            placeholder={"مانند 09215863622"}
          />
          <InputGroup
            iconName={"discover"}
            onchange={onchangeInput}
            id="postalcode"
            label="کد پستی"
            placeholder={"مانند 145592456987"}
          />
        </div>
        <div className="flex flex-row justify-between w-full gap-5 mt-25">
          <InputGroup
            iconName={"global"}
            label="استان و شهر"
            onchange={onchangeInput}
            id="city"
            width="w-1/3"
            placeholder={"مانند فارس - شیراز"}
          />
          <InputGroup
            iconName={"gps"}
            label="آدرس گیرنده"
            onchange={onchangeInput}
            id="address"
            width="w-2/3"
            placeholder={
              " مانند آدرس:  خیابان ستارخان، بن بست 21، فرعی 3، ساختمان هیبا، طبقه دوم، واحد 4 "
            }
          />
        </div>
        <TitleDetail title={"اطلاعات محصول"} />
        <div className="flex flex-row justify-between w-full gap-5 mt-25">
          <SearchOrder />
        </div>
        <div className="mt-25  ">
          <Table
            thData={HeaderOrderAdd}
            tableData={jsonArray}
            thwidth="w-27.1"
          />
        </div>

        <div className="flex flex-row justify-between w-full gap-5 mt-25 pb-7.5px">
          <InputGroup
            iconName={"coin"}
            label="مبلغ سفارش"
            readOnly={true}
            width={"w-1/3"}
            value={totalCost + ""}
          />
          <SelectModal
            iconName={"truck"}
            label={"نحوه ارسال"}
            readOnly={true}
            style={"w-1/3 justify-between"}
            values={postvalue}
            onchange={onchangeSend}
            maxWidth="256px"
            minWidth={"150px"}
            able={true}
            placeholder={"یک گزینه را انتخاب کنید"}
          />
          <InputGroup
            iconName={"box-search"}
            label="کد پیگیری سرویس ارسال (در صورت نیاز)"
            onchange={onchangeInput}
            id="codeSend"
            readOnly={false}
            width={"w-1/3"}
            placeholder="مانند 1453645768562456987"
          />
        </div>
        <div className="w-52 mr-auto pb-7.5px">
          <BtnModal text={"ثبت و افزودن سفارش"} accept={doneAdd} />
        </div>
        <Toaster />
      </div>
      {/* <TsbleSearch/> */}
    </>
  );
};

export default AddOrder;
